import { AlertDTO } from "../model/alerts/alert-dto";
import { CyberAttackManagementStatusEnum } from "../model/alerts/attacks/cyber-attack-management-status-enum";

export class Utils {
    public getStatus(alert: AlertDTO): CyberAttackManagementStatusEnum {
        let cyberAttackManagementStatus = CyberAttackManagementStatusEnum;
        if (alert.attacks?.length != 0) {
            let result = cyberAttackManagementStatus.Done;
            for (let attack of alert.attacks!) {
                if (attack.cyberAttackManagements.length == 0) {
                    result = cyberAttackManagementStatus.NeedAction;
                    break;
                }
                for (let attackManagement of attack.cyberAttackManagements) {
                    if (attackManagement.status == cyberAttackManagementStatus.Pending) {
                        result = cyberAttackManagementStatus.Pending;
                        break;
                    }
                    if (attackManagement.status == cyberAttackManagementStatus.PendingUnmanage) {
                        result = cyberAttackManagementStatus.PendingUnmanage;
                        break;
                    }
                }
            }
            return result;
        } else {
            return cyberAttackManagementStatus.NeedAction;
        }
    }

    private static isValidDateString(str: string) {
        const isoNoTZRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?$/;
        if (!isoNoTZRegex.test(str)) return false;
        const date = new Date(str + 'Z');

        return !isNaN(date.getTime());
    }

    private static hasTimezone(str: string) {
        return /Z$|[+-]\d{2}:\d{2}$/.test(str);
    }

    public static prepareUTCDateString(str: any) {
        if (this.hasTimezone(str)) {
            return str;
        }

        if (!this.isValidDateString(str)) {
            throw new Error("Invalid date or incorrect format.");
        }

        return str + 'Z';
    }
}
